import * as _ from "lodash"
import { stringIsBlank } from "../utils/strings";
import Message from "./Message";

// {
//   "text": "{{nobox}}<div class=\"system-message\">This user wants to fling with you ;)</div>
//   \n
//   \n[[heya ;) nice profile pic->proto-fapp-A-1]]
//   \n[[DO YOU WANNA SEE MY BALONEY PONY?->proto-fapp-Z-1]]",
//   "links": [
//   {
//     "name": "heya ;) nice profile pic",
//     "link": "proto-fapp-A-1",
//     "pid": "2"
//   }

export default class Passage {
  constructor(fields) {
    _.assign(this, fields);
  }

  links;
  tags;
  name;
  pid;
  text;
  story;

  getMessages() {
    let rawMessageList = this.text.split(/[\n]+/);
    let i = 0;
    return _.reduce(rawMessageList, (resultList, rawMessage) => {
      if (stringIsBlank(rawMessage)) return resultList;
      const message = new Message(rawMessage, this.pid, i);
      i++;
      return resultList.concat([message]);
    }, []);
  }

  getReceivableMessages() {
    return _.filter(this.getMessages(), it => it.isIncoming() || it.isHtml())
  }

  get possibleOutgoingMessages() {
    return _.filter(this.getMessages(), it => it.isOutgoing())
  }
}